/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  .scale {
    display: flex;
    align-items: baseline;
    &.imperial {
      align-items: initial;
    }
  }

  .line {
    width: ${({ metricWidth }) => metricWidth};
    height: 5.22px;
    border: 2px solid #ffffff;
    border-top: none;
    &.imperial {
      width: ${({ imperialWidth }) => imperialWidth};
      border-top: 2px solid #ffffff;
      border-bottom: none;
    }
  }

  .value {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    color: #ffffff;
    min-width: 42px;
    margin-right: 5px;
  }

  @media (max-width: 768px) {
    .scale {
      flex-direction: column;
      align-items: center;
      &.imperial {
        flex-direction: column-reverse;
      }
    }

    .value {
      margin: 0;
      margin-bottom: -3px;
      &.imperial {
        margin-bottom: 0;
        margin-top: -3px;
      }
    }
  }
`;
